// extracted by mini-css-extract-plugin
export default {"pagination":"Pagination_pagination__9FrgN","arrows":"Pagination_arrows__wMGZJ","page":"Pagination_page__yqY0B"};